import { all, fork } from 'redux-saga/effects'

import checkLocalisationUpdateSaga from './sagas/checkLocalisationUpdateSaga'

function* LocalisationService() {
  yield all([fork(checkLocalisationUpdateSaga)])
}

export default LocalisationService
